import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../utils/axiosconfig';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [accessToken, setAccessToken] = useState(null);
  const [user, setUser] = useState(null);
  const [bookingInfo, setBookingInfo] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setAccessToken(token);
    }

    const savedBookingInfo = localStorage.getItem('bookingInfo');
    if (savedBookingInfo) {
      setBookingInfo(JSON.parse(savedBookingInfo));
    }
  }, []);

  const login = (token) => {
    setAccessToken(token);
    localStorage.setItem('token', token);
  };

  const getUserDetail = async () => {
    if (accessToken) {
      const response = await api.get('/user');
      setUser(response.data.user);
    }
  };

  const logout = () => {
    setAccessToken(null);
    localStorage.removeItem('token');
  };

  const saveBookingInfo = (info) => {
    setBookingInfo(info);
    localStorage.setItem('bookingInfo', JSON.stringify(info));
  };

  useEffect(() => {
    getUserDetail()
  }, [accessToken])

  return (
    <AuthContext.Provider value={{ accessToken, login, logout, bookingInfo, saveBookingInfo, user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);